module.exports = __webpack_public_path__ + "20bc45a94cf056229009317f66d1f69b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/message.png
// module id = PZh6
// module chunks = 27